import { useEffect, useState } from 'react';
import { getAdminHandbook, GetAdminHandbookOutputType } from 'zite-endpoints-sdk';
import { Skeleton } from '@/components/ui/skeleton';
import { Button } from '@/components/ui/button';
import { Plus, BookOpen, Search } from 'lucide-react';
import { Input } from '@/components/ui/input';

export default function HandbookAdminSection() {
  const [sections, setSections] = useState<any[]>([]);
  const [loading, setLoading] = useState(true);
  const [search, setSearch] = useState('');

  useEffect(() => {
    getAdminHandbook({}).then((d: any) => {
      setSections(d.sections || []);
    }).catch(() => {}).finally(() => setLoading(false));
  }, []);

  const filtered = sections.filter(s =>
    (s.title || '').toLowerCase().includes(search.toLowerCase())
  );

  if (loading) return <div className="space-y-3">{[1,2,3].map(i => <Skeleton key={i} className="h-12" />)}</div>;

  return (
    <div>
      <div className="flex items-center justify-between mb-4">
        <h2 className="text-lg font-bold text-foreground">Handbook Sections</h2>
        <Button size="sm"><Plus className="w-4 h-4 mr-1" /> Add Section</Button>
      </div>

      <div className="flex items-center gap-3 mb-4">
        <div className="relative flex-1 max-w-sm">
          <Search className="w-4 h-4 text-muted-foreground absolute left-2.5 top-1/2 -translate-y-1/2" />
          <Input placeholder="Search handbook…" value={search} onChange={e => setSearch(e.target.value)} className="pl-9" />
        </div>
      </div>

      {filtered.length === 0 ? (
        <div className="text-center py-12 border border-dashed border-border rounded-lg">
          <BookOpen className="w-10 h-10 text-muted-foreground mx-auto mb-2 opacity-50" />
          <p className="text-sm text-muted-foreground">No handbook sections found</p>
        </div>
      ) : (
        <div className="space-y-2">
          {filtered.map((s: any) => (
            <div key={s.id} className="flex items-center gap-4 p-4 bg-card border border-border rounded-lg">
              <div className="w-8 h-8 rounded bg-primary/10 flex items-center justify-center text-xs font-bold text-primary shrink-0">
                {s.sortOrder || '—'}
              </div>
              <div className="flex-1 min-w-0">
                <p className="font-medium text-foreground truncate">{s.title || 'Untitled'}</p>
                <p className="text-xs text-muted-foreground">{s.category || 'Uncategorized'}</p>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
